var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',{attrs:{"id":`products-${_vm.productKey}`,"options":_vm.productsForForm,"type":"checkbox","value":_vm.products[0].id,"multiple":true,"validation":"required","placeholder":_vm.title,"validation-messages":{
		'required': 'Выберите хотя бы 1 значение'
	}},on:{"input":_vm.handleInput},model:{value:(_vm.selectedProducts),callback:function ($$v) {_vm.selectedProducts=$$v},expression:"selectedProducts"}})
}
var staticRenderFns = []

export { render, staticRenderFns }